import { useQuery } from '@tanstack/react-query';
import { configApi } from '../../configApi';

interface IParams {
  selective_process?: string;
  status?: string;
  remove_pagination?: boolean;
  show_members?: boolean;
  resource_period_id?: string;
}

export interface IExaminationBoardResponse {
  id: string;
  name: string;
  selective_process: string;
  selective_process_name: string;
  public_notice_number: string;
  academic_unit: string;
  study_sector: string;
  status: string;
  status_display: string;
  total_members: number;
  total_vacancies: number;
  members: IMembersResponse[];
  created_at: {
    br: string;
    us: string;
  };
}

interface IMembersResponse {
  colaborator: string;
  colaborator_name: string;
  id: string;
  order: number;
  role: string;
  role_display: string;
}

const GetExaminationBoard = async <T>(params?: IParams) => {
  const response = await configApi.get<T>(`api/examination-boards/`, {
    params: {
      remove_pagination: params?.remove_pagination,
      selective_process: params?.selective_process,
      status: params?.status,
      show_members: params?.show_members || undefined,
      resource_period_id: params?.resource_period_id,
    },
  });
  return response.data;
};

export const useGetExaminationBoard = <T>(params?: IParams, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['examination_board_list', params],
    queryFn: () => GetExaminationBoard<T>(params),
    refetchOnWindowFocus: false,
    gcTime: 0,
    enabled,
  });
};
